define('models/OfferedProductModel',['underscore', 'ObjectModel', 'app', 'formatPrice'], function (_, ObjectModel, app, formatPrice) {
    //
    // Model OfferedProduct
    //

    // sauces, wasabi, gimgembre, baguettes


    var _SAUCE_SUCREE_ = 'sauce_sucree',
        _SAUCE_SALEE_ = 'sauce_salee',
        _GINGEMBRE_ = 'gingembre',
        _WASABI_ = 'wasabi',
        _BAGUETTES_ = 'baguettes'
    ;
    var SLUG_CONSUMABLES = [_BAGUETTES_,_SAUCE_SUCREE_,_SAUCE_SALEE_,_GINGEMBRE_,_WASABI_];

    function getSlugFromId(id_product){
        return _.find(SLUG_CONSUMABLES,function(slug){
            var slug_id_product = app.c('_'+slug.toUpperCase()+'_');
            return slug_id_product == id_product;
        }) || false;
    }

    var sauceTestSlug = /^sauce_/,
        icons = {
            'baguettes': 'rods',
            'sauce_sucree': 'sweet-sauce',
            'sauce_salee': 'salty-sauce',
            'gingembre': 'ginger',
            'wasabi': 'wasabi',
            'sauce-mayo-spicy': 'sweet-sauce',
            'default': 'sweet-sauce'
        }

    function idExistsInQuantityList(id, list) {
        var q = 0;
        if (!_(list).isUndefined() && !_(list.list).isUndefined() && !_(list.list[id]).isUndefined()) {
            q += parseInt(list.list[id]);
        }
        return q;
    }

    var OfferedProductModelPrototype = {

        name: 'OfferedProductModel',
        idAttribute: 'slug',

        initialize: function () {
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this, arguments);
            //
            var model = this, id_product = model.get('id_product');
            var slug = getSlugFromId(id_product), options = {
                slug: id_product,
                fix:false,
                isSauce: false,
                quantity: false,
                free: false
            };
            if (!!slug) {
                var isSauce = sauceTestSlug.test(slug);
                options = {
                    slug: slug,
                    fix: true,
                    isSauce: isSauce,
                    quantity: false,
                    free: false
                };
            }
            model.set(options)
        },
        setup: function () {
            var model = this,
                slug = model.id,
                cart = model.collection.cart,
                idProduct = model.get('id_product'),
                findProp = {id_product: idProduct},
                quantity = 0;
            if (slug == _BAGUETTES_) {
                var baguettes = cart.getConsumables().findWhere(findProp);
                quantity = baguettes ? parseInt(baguettes.getQuantity()) : 0;
            } else {
                if (model.get('fix') == true) {
                    var static_suffix = model.isSauce() ? '' : '_static',
                        offeredProducts_qty = cart.get('consumables_qty'),
                        offeredProducts_qty_gratuit = offeredProducts_qty['gratuit' + static_suffix],
                        offeredProducts_qty_payant = offeredProducts_qty['payant' + static_suffix];
                    quantity += idExistsInQuantityList(idProduct + '-1', offeredProducts_qty_gratuit);
                    quantity += idExistsInQuantityList(idProduct, offeredProducts_qty_payant);
                } else {
                    var product = cart.getProducts().findWhere(findProp)
                    if (product) {
                        quantity = product.getQuantity();
                    } else {
                        quantity = 0;
                    }
                }
            }
            model.setQuantity(quantity);
        },
        isSauce: function () {
            return this.get('isSauce');
        },
        onUpdate: function (e, a) {
        },
        getProduct: function () {
            return app.getProduct(this.get('id_product'));
        },
        getPictureUrl: function(useAlt){
            var product = this.getProduct(), picture = product.getPicture();
            if(useAlt){
                picture = product.getPictureByType('productCustom') || picture;
            }
            return product.getPictureUrl('consumable',picture);
        },
        getPrice: function () {
            return this.getProduct().getPrice('ttc', true, app.getCart());
        },
        isBuyableInContext:function(){
            return this.getProduct().isBuyableInContext();
        },
        isVisibleInContext:function(){
            return this.getProduct().isVisibleInContext();
        },
        getQuantity: function () {
            var model = this;
            return model.isBuyableInContext() ? model.get('quantity') || 0 : 0;
        },
        setQuantity: function (q) {
            this.set('quantity', parseInt(q));
        },
        getQuantityMax: function () {
            var model = this,
                cart = app.getCart(),
                qty = 0, adding_payment = 0;

            if( !model.isBuyableInContext()){
                return 0;
            }
            if (model.get('fix') == true) {


                switch (model.id) {
                    case _GINGEMBRE_ :
                    case _WASABI_ :
                        adding_payment = 4;
                        break;
                    case _SAUCE_SUCREE_ :
                    case _SAUCE_SALEE_ :
                        adding_payment = 5;
                        return model.getSauceQuantityMax(adding_payment);
                        break;

                }
            } else {
                var presetConsumables = this.collection.cart.get('presetConsumables'),
                    suffix = 'available_nb_baguettes';
                var max = parseInt(presetConsumables[suffix]);
                var product = cart.getProducts().find({id_product: model.get('id_product')})
                if (product && product.getQuantity() > max)
                    return parseInt(product.getQuantity());
                else
                    return max;
            }

            qty += model.getQuantityFree();
            qty += adding_payment;
            return parseInt(qty) || 0;
        },
        getPreset: function () {
            var presetConsumables = this.collection.cart.get('presetConsumables'),
                suffix = this.id.replace('_', '');
            return parseInt(presetConsumables['preset' + suffix]);
        },
        resetPreset: function () {
            this.set('quantity', this.getPreset());
        },
        getQuantityFree: function () {
            var model = this,
                qty = 0,
                slug = model.id,
                suffix = slug,
                collection = model.collection,
                cart = collection.cart,
                freeQuantity;
            //
            if( !model.isBuyableInContext()){
                return 0;
            }
            if (sauceTestSlug.test(slug)) suffix = 'sauce';

            try {
                freeQuantity = cart.get('presetConsumables')['available_nb_' + suffix];
                //
            }catch(err){
                freeQuantity = 0;
            }
            qty += freeQuantity;

            if (slug == _SAUCE_SUCREE_ ) {
                qty -= collection.getQuantityBySlug(_SAUCE_SALEE_);
                qty = (qty < 0) ? 0 : qty;
            }

            return parseInt(qty) || 0;
        },
        getSauceQuantityMax: function (adding_payment) {
            var model = this,
                collection = model.collection,
                freeQuantity = collection.cart.get('presetConsumables')['available_nb_sauce'];
            return parseInt(freeQuantity + adding_payment);
        },
        getIcon: function () {
            return icons[this.id] || icons['default'];
        },
        getName: function (withSauceAsterisk) {
            var name = this.getProduct().getName();
            if(this.isSauce()) name += '*';
            return name;
        },
        formatAdditionalPrice: function () {
            var product = this.getProduct();
            return product.getPrice() > 0 ? "+ " + product.formatPrice() : "";
        },
        formatPrice: function(displayIncluded){
            return this.formatPriceQuantity(this.getQuantity(),true,displayIncluded);
        },
        formatPriceType: function(){
            var model = this;
            return !!model.formatPrice(true) ? (!!model.formatPrice() ? model.isBuyableInContext()?'pay':'unavailable':'included'):'empty';
        },
        formatPriceQuantity: function (qty,hideQuantity,displayIncluded) {
            // gère le formatage quantité + prix supplémentaire
            var model = this,
                product,
                free = model.get('free') || 0,
                fix = model.get('fix') || 0,
                buyable = model.isBuyableInContext(),
                label = hideQuantity?'':qty,
                additionalQty = 0;
            if(!buyable){
                product = model.getProduct();
                return product.getUnavailableMessage();
            }
            if (!!fix) {
                if ((qty > free) && (qty !== 0)) {
                    additionalQty = qty - free;
                }
            } else {
                additionalQty = qty;
            }
            var hasExtraPrice = false,
                hasAdditionalQty = additionalQty > 0,
                product = model.getProduct(),
                price = product.getPrice('ttc', true),
                additionalCost = product.formatPriceQty('ttc', additionalQty, false, true);
            if(hasAdditionalQty){
                // formatage du coût additionnel
                hasExtraPrice = price > 0;
                if(hasExtraPrice){
                    // si le produit est payant et qu'il y a un coût supplémentaire
                    label +=  ' ' + app.t("(+%s)", "Cart", additionalCost);
                }
            }

            if(displayIncluded && !hasExtraPrice){
                if(fix && !!free){
                    label = app.t('inclus','Cart');
                }else{
                    // on affiche le prix unitaire si le premier est payant
                    label = product.formatPriceQty('ttc', 1, false, true);
                }
            }
            return label;
        },
        formatQuantity: function (wrap, ignoreNull) {
            var model = this,
                slug = this.id,
                quantity = model.getQuantity(slug),
                plural = quantity > 1,
                notNull = quantity > 0,
                context = 'Cart',
                word = '',
                translation = '';
            if (ignoreNull === true && !notNull) return '';
            switch (slug) {
                case _BAGUETTES_:
                    word = plural ? '%s paires de baguettes' : notNull ? 'une paire de baguettes' : 'pas de baguette';
                    break;
                case _SAUCE_SUCREE_:
                    word = plural ? '%s sauces sucrées' : notNull ? 'une sauce sucrée' : 'pas de sauce sucrée';
                    break;
                case _SAUCE_SALEE_:
                    word = plural ? '%s sauces salées' : notNull ? 'une sauce salée' : 'pas de sauce salée';
                    break;
                case _GINGEMBRE_:
                    word = plural ? '%s gingembres' : notNull ? 'un gingembre' : 'pas de gingembre';
                    break;
                case _WASABI_:
                    word = plural ? '%s wasabis' : notNull ? 'un wasabi' : 'pas de wasabi';
                    break;
                case 'sauce-mayo-spicy':
                    word = plural ? '%s sauces mayo spicy' : notNull ? '%s sauce mayo spicy' : 'pas de sauce mayo spicy';
                    break;
                default:
                    return '<' + wrap + '>' + quantity + '  ' + model.getProduct().getName() + '</' + wrap + '>';
            }

            translation = t(word, context, quantity);
            if (wrap) {
                return '<' + wrap + '>' + translation + '</' + wrap + '>';
            }
            return translation;
        },
    };

    var OfferedProductModel = ObjectModel.extend(OfferedProductModelPrototype);

    return OfferedProductModel;
});
